import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { SharedModule } from 'app/shared/shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports     : [
        RouterModule,
        A11yModule,
        SharedModule,
        TranslocoModule
    ],
    exports     : [
        LayoutComponent
    ]
})
export class LayoutModule
{
}
